"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { CalendarCheck } from "lucide-react";

export default function SlugFloatButton() {
      const router = useRouter();
      const [visible, setVisible] = useState(true);

      useEffect(() => {
            const form = document.getElementById("treatment-contact-form");
            if (!form) return;

            const observer = new IntersectionObserver(
                  ([entry]) => setVisible(!entry.isIntersecting),
                  { threshold: 0.2 }
            );
            observer.observe(form);
            return () => observer.disconnect();
      }, []);

      const handleClick = () => {
            const form = document.getElementById("treatment-contact-form");
            if (form) {
                  form.scrollIntoView({ behavior: "smooth", block: "center" });
            } else {
                  router.push("/iletisim");
            }
      };

      return (
            <div
                  className={`fixed z-40 transition-all duration-500 ease-in-out
                        bottom-24 lg:bottom-8 left-1/2 -translate-x-1/2
                        ${visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-6 pointer-events-none"}`}
            >
                  <button
                        onClick={handleClick}
                        className="flex items-center gap-2.5 bg-[#A68F72] hover:bg-[#8f7a61] text-white font-bold px-6 py-3.5 rounded-full shadow-xl shadow-[#A68F72]/40 active:scale-95 transition-all text-sm whitespace-nowrap"
                  >
                        <CalendarCheck size={18} />
                        Hemen Başvur
                  </button>
            </div>
      );
}
